import { Controller, useFormContext } from 'react-hook-form'

import moment from 'moment'

import DayPicker from 'modules/core/components/DayPicker'
import i18n from 'modules/core/lib/i18n'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

const FIELD_NAME = 'effectiveOn'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  onEffectiveOnChange: (value: string) => void
  isAutomaticExpensable?: boolean
}

const EffectiveOnField = ({
  isFieldMandatory,
  onEffectiveOnChange,
  isAutomaticExpensable = false,
  isFieldReadOnly,
  resourceType = 'expense',
}: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  const isReadOnly = isFieldReadOnly || isAutomaticExpensable
  const isExpense = resourceType === 'expense'
  const fieldLabel = isExpense
    ? i18n.t('expenses_v2.forms.fields.effective_on.label')
    : i18n.t('expenses_v2.forms.fields.trip_date.label')

  return (
    <Controller
      control={control}
      name={FIELD_NAME}
      render={({ field }) => (
        <DayPicker
          label={fieldLabel}
          mode={'single'}
          mandatory={isFieldMandatory}
          maxDate={moment().endOf('day')}
          readonly={isReadOnly}
          placeholder={i18n.t('expenses_v2.forms.fields.effective_on.placeholder')}
          value={field.value}
          valueFormat="backend"
          onChange={(value) => {
            field.onChange(value)
            onEffectiveOnChange(value)
          }}
          error={castError(errors?.effectiveOn)}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(EffectiveOnField, FIELD_NAME))
